import * as React from "react";
import OwlCarousel from "react-owl-carousel";
import PropTypes from "prop-types";

export default class Carousel extends React.Component {
  static propTypes = {"marketingAssets": PropTypes.array};

  static defaultProps = {"marketingAssets": []};

  constructor (props) {
    super(props);
    this.state = {"currentItem": 0};
    this.ref = React.createRef();
  }

  shouldComponentUpdate (props, state) {
    const {currentItem} = this.state;
    return state.currentItem !== currentItem;
  }

  render () {
    const imageUrlPrefix = "https://karat-herokuapp-com.freetls.fastly.net/s3media";
    const {marketingAssets} = this.props;

    return (
      <OwlCarousel
        className="carousel owl-theme"
        dots
        items={1}
        loadedClass="inline-block"
        ref={this.ref}
      >
        {
          marketingAssets.map(marketingAsset =>
            <a
              href={marketingAsset.link_url}
              key={`marketing-asset-${marketingAsset.id}`}
            >
              <img
                className="wishlist-link-recently-added"
                src={`${imageUrlPrefix}${marketingAsset.image_url}`}
              />
            </a>)
        }
      </OwlCarousel>
    );
  }
}
